"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Balls = (function () {
    function Balls() {
        this.colors = {
            'red': [1, 9, 17, 25, 33, 41],
            'green': [2, 10, 18, 26, 34, 42],
            'blue': [3, 11, 19, 27, 35, 43],
            'purple': [4, 12, 20, 28, 36, 44],
            'brown': [5, 13, 21, 29, 37, 45],
            'yellow': [6, 14, 22, 30, 38, 46],
            'orange': [7, 15, 23, 31, 39, 47],
            'black': [8, 16, 24, 32, 40, 48]
        };
    }
    Balls.prototype.getByColor = function (color) {
        return this.colors[color];
    };
    return Balls;
}());
exports.default = Balls;



//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/ts/balls/balls.ts
// module id = 1202
// module chunks = 0